<template>
  <div>
    <div id="jobs-leftcol" class="card">
      <div :class="headerClass" class="card-header ch-alt visible-sm visible-xs">
        <div class="pointer" @click="toggleFilters">
          <span class="ucase">{{ $t('Filter your results') }}</span>
          <span class="caret" />
        </div>
      </div>
      <transition name="expand">
        <div v-if="displayFilter" class="card-body card-padding filters">
          <SelectBoxes
            v-for="(selector, id) in refSelectors"
            :key="id"
            :children="selector.children"
            :ref-list-obj="selector.refObj"
            :set-title="selector.title"
            :set-type="selector.type"
            :set-name="selector.name"
            :collapsable="selector.collapsable"
            :set-approved="selector.approved"
            :display="selector.display"
            :display-to-company="selector.displayToCompany"
            :mutator="selector.mutator"
            :start-collapsed="selector.startCollapsed"
          />
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import SelectBoxes from '@/components/SelectBoxes.vue'

export default {
  name: 'LeftSelectorBar',
  components: {
    SelectBoxes,
  },
  props: {
    // List of selectors, see data() for details
    // Example of selector object
    // selectors: [{
    //   refObj: null,
    //   title: null,
    //   type: null,
    //   name: null,
    //   approved: false,
    //   display: true,
    //   mutator: null,
    //   multiple: false,
    //   collapsable: false
    //   displayToCompany: true
    //   startCollapsed
    // }],
    refSelectors: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      default: 'Filter your results',
    },
    headerClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      // Turns on / of if we should display the filter
      displayFilter: true,
    }
  },
  created() {
    if (!this.refSelectors.length) {
      // eslint-disable-next-line vue/no-mutating-props -- Baseline eslint ignore please fix if working on this
      this.refSelectors = [this.refSelectors]
    }
    this.displayFilter = window.innerWidth >= 768
  },
  methods: {
    toggleFilters() {
      this.displayFilter = !this.displayFilter
    },
  },
}
</script>

<style scoped lang="scss">
.filters {
  overflow: hidden;
}
</style>
